var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_3469",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.99196H22V21.158H2V2.99196Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_3469)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14.971V17.016C3.5 17.722 3.774 18.385 4.273 18.884C4.772 19.383 5.436 19.658 6.141 19.658H17.857C19.313 19.658 20.499 18.474 20.5 17.018V14.97C19.214 14.637 18.261 13.466 18.26 12.077C18.26 10.688 19.213 9.51696 20.499 9.18296L20.5 7.13796C20.501 5.67996 19.318 4.49296 17.861 4.49196H6.144C4.687 4.49196 3.501 5.67696 3.5 7.13396V9.25096C3.986 9.36696 4.437 9.60596 4.812 9.95596C5.381 10.487 5.709 11.207 5.737 11.985C5.74 13.451 4.787 14.635 3.5 14.971ZM17.857 21.158H6.142C5.035 21.158 3.995 20.728 3.212 19.945C2.43 19.162 2 18.122 2 17.016V14.316C2 13.902 2.336 13.566 2.75 13.566C3.574 13.565 4.24 12.897 4.239 12.077C4.225 11.659 4.065 11.311 3.789 11.053C3.514 10.795 3.158 10.654 2.776 10.675C2.569 10.677 2.375 10.606 2.229 10.465C2.083 10.324 2 10.128 2 9.92496V7.13496C2.001 4.84996 3.86 2.99196 6.144 2.99196H17.856C20.146 2.99296 22.002 4.85496 22 7.13896V9.83796C22 10.252 21.664 10.588 21.25 10.588C20.429 10.588 19.76 11.256 19.76 12.076C19.761 12.898 20.429 13.566 21.25 13.566C21.664 13.566 22 13.902 22 14.316V17.016C21.999 19.3 20.14 21.158 17.857 21.158Z",
    fill: "url(#paint0_linear_44_3469)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1039 11.373L10.6129 11.869C10.8889 12.14 11.0139 12.526 10.9479 12.903L10.8279 13.601L11.4569 13.27C11.7959 13.089 12.2029 13.09 12.5449 13.272L13.1699 13.6L13.0499 12.901C12.9869 12.518 13.1129 12.135 13.3859 11.869L13.8949 11.373L13.1899 11.271C12.8119 11.216 12.4839 10.978 12.3149 10.633L11.9999 9.99596L11.6849 10.634C11.5159 10.978 11.1879 11.216 10.8079 11.271L10.1039 11.373ZM13.6179 15.379C13.4319 15.379 13.2459 15.334 13.0739 15.243L11.9999 14.68L10.9249 15.244C10.5289 15.451 10.0579 15.418 9.69789 15.156C9.33689 14.893 9.15989 14.457 9.23489 14.017L9.43989 12.821L8.57089 11.974C8.25189 11.663 8.13789 11.206 8.27489 10.782C8.41289 10.357 8.77289 10.052 9.21389 9.98796L10.4179 9.81196L10.9549 8.72296C11.1519 8.32296 11.5519 8.07396 11.9999 8.07396C12.4459 8.07396 12.8469 8.32296 13.0439 8.72396L13.5819 9.81196L14.7839 9.98796C15.2259 10.052 15.5869 10.357 15.7239 10.782C15.8609 11.206 15.7479 11.663 15.4279 11.975L14.5579 12.822L14.7639 14.017C14.8389 14.458 14.6609 14.895 14.2989 15.157C14.0949 15.304 13.8569 15.379 13.6179 15.379Z",
    fill: "url(#paint1_linear_44_3469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_3469",
    x1: 12,
    y1: 2.99196,
    x2: 8.64641,
    y2: 19.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_3469",
    x1: 11.9995,
    y1: 8.07396,
    x2: 10.5731,
    y2: 14.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSvg);
export default __webpack_public_path__ + "static/media/TicketSVG.6c064c81a89acdabf7990c84c87c1fd9.svg";
export { ForwardRef as ReactComponent };